module.exports = __webpack_public_path__ + "img/image-equilibrium.e39748ba.jpg";